import React, { Component } from 'react';
import ErrorMessage from './ErrorMessage';
import '../../assets/styles/Converter/Input.sass';

class Input extends Component {
  setInputData(e) {
    let data = { valueToConvert: e.target.value };
    this.props.setInputValue(data);
  }

  render() {
    return (
      <div className="Input">
        <input className={`Input__field ${this.props.hasError && 'hide-placeholder'}`}
               placeholder={this.props.placeholder}
               type="number"
               step="any"
               onChange={this.setInputData.bind(this)} />

        <ErrorMessage hasError={this.props.hasError}/>
      </div>
    );
  }
}

export default Input;
